/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { colour } from '../models/colour';
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { lookupRequest } from '../models/lookupRequest';
import type { vw_colour } from '../models/vw_colour';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ColourService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Lookup
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postColourLookup({
        requestBody,
    }: {
        requestBody: lookupRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/colour/lookup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postColourDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/colour/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of Colours
     * @returns vw_colour A list of colours
     * @throws ApiError
     */
    public getColours(): CancelablePromise<Array<vw_colour>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/colours',
        });
    }

    /**
     * Get colour by id
     * @returns vw_colour The colour data
     * @throws ApiError
     */
    public getColour({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_colour> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/colour/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Colour not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a colour by id
     * @returns any Colour deleted successfully
     * @throws ApiError
     */
    public deleteColour({
        id,
    }: {
        /**
         * The colour id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/colour/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Colour not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Colour
     * @returns any Colour created successfully
     * @throws ApiError
     */
    public postColour({
        requestBody,
    }: {
        requestBody: colour,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/colour',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Colour
     * @returns any Colour updated successfully
     * @throws ApiError
     */
    public putColour({
        requestBody,
    }: {
        requestBody: colour,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/colour',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Colour not found`,
                500: `Internal server error`,
            },
        });
    }

}
